import './topbar.scss';
import { useEffect, useState } from 'react';
import { useLayoutContext } from '../../context/game';

export default function Topbar({title,count}){
	const [context] = useLayoutContext();
	const [blinkers,setBlinkers] = useState([]);
	useEffect(()=>{
		if(!context?.hasStarted) return;
		const blinkersArr = [];
		for(let i = 0; i < count; i++){
			let state;
			switch(true){
				case(i === context?.disabled?.length):
					state = 'current';
				break;
				case(i < context?.disabled?.length):
					state = 'rolled';
				break;
				default:
					state = 'pending'
				break;
			}
			blinkersArr.push(state)
		}
		setBlinkers(blinkersArr);

	},[context])
	const {disclaimer} = window.global_data || {};
	return(
		<div className="topbar">
			<div className="container">
				<h6 className="topbar-title mb-0">{title || 'Užduotis'}</h6>
				<hr />
				{context?.hasStarted && (
					<div className="rolled">
						<div style={{fontWeight:500,fontSize:20,fontFamily:'Acrom'}}>
							Atsakyta {context?.disabled?.length || 0}/{count}
						</div>
						<div className="blinker-wrap">
							{blinkers && blinkers.map((state,index)=>{
								return(
									<div key={'blinker'+index} className={`blinker ${state}`}></div>
								)
							})}
						</div>
					</div>
				)}
			</div>
			{disclaimer && (
				<div className="topbar-text">
					<div className="container">
						{disclaimer}
					</div>
				</div>
			)}
		</div>
	)
}